"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsavrSession = void 0;
var CardsavrSDKError_1 = __importDefault(require("./CardsavrSDKError"));
var CardsavrRestError_1 = __importDefault(require("./CardsavrRestError"));
var CardsavrSessionResponse_1 = __importDefault(require("./CardsavrSessionResponse"));
var CardsavrSessionUtilities_1 = require("./CardsavrSessionUtilities");
var CardsavrCrypto = __importStar(require("./CardsavrSessionCrypto"));
var package_json_1 = require("../../package.json");
//import { Agent, ProxyAgent } from 'undici';
var node_fetch_1 = __importDefault(require("node-fetch"));
var https_1 = require("https");
var https_proxy_agent_1 = require("https-proxy-agent");
var CardsavrSession = /** @class */ (function () {
    function CardsavrSession(baseUrl, sessionKey, appName, rejectUnauthorized, cardsavrCert, proxy, debug) {
        if (rejectUnauthorized === void 0) { rejectUnauthorized = true; }
        if (debug === void 0) { debug = false; }
        var _this = this;
        this.setSessionHeaders = function (headersObject) {
            Object.assign(_this._headers, headersObject);
        };
        this.removeSessionHeader = function () {
            var headerKeys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                headerKeys[_i] = arguments[_i];
            }
            if (!_this._headers) {
                throw new CardsavrSDKError_1.default([], "You have not set any header values.");
            }
            else {
                headerKeys.forEach(function (headerKey) {
                    if (!Object.prototype.hasOwnProperty.call(_this._headers, headerKey)) {
                        throw new CardsavrSDKError_1.default([], "Header value could not be found.");
                    }
                    delete _this._headers[headerKey];
                });
            }
        };
        this._makeSafeKeyHeader = function (safeKey, newKey) {
            if (newKey === void 0) { newKey = false; }
            return newKey ? {
                "x-cardsavr-new-cardholder-safe-key": safeKey
            } : {
                "x-cardsavr-cardholder-safe-key": safeKey
            };
        };
        this.getSerializedSessionData = function () {
            return JSON.stringify(_this._sessionData);
        };
        this.deserializeSessionData = function (json) {
            if (json && _this._sessionData.sessionToken) {
                _this._sessionData = JSON.parse(json);
                _this.setSessionHeaders({
                    "x-cardsavr-session-jwt": _this._sessionData.sessionToken
                });
            }
        };
        this.setSessionToken = function (key) {
            if (key) {
                _this._sessionData.sessionToken = key;
                _this.setSessionHeaders({
                    "x-cardsavr-session-jwt": key
                });
            }
        };
        this.sendRequest = function (path_1, method_1, requestBody_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([path_1, method_1, requestBody_1], args_1, true), void 0, function (path, method, requestBody, headersToAdd) {
                var headers, unencryptedBody, sessionKey, authHeaders, config, response, agent, body, _a, response_headers, csr, _b, _c;
                var _d;
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            headers = Object.assign({}, this._headers, headersToAdd);
                            unencryptedBody = requestBody;
                            if (!this._sessionData.sessionKey) {
                                throw new CardsavrSDKError_1.default(["Can't send request with a terminated session."]);
                            }
                            sessionKey = this._sessionData.sessionKey;
                            // Encrypt the cardholder-safe-header(s) if they are in this request
                            CardsavrCrypto.Encryption.encryptSafeKeys(headers, sessionKey);
                            if (!requestBody) return [3 /*break*/, 2];
                            return [4 /*yield*/, CardsavrCrypto.Encryption.encryptRequest(sessionKey, requestBody)];
                        case 1:
                            requestBody = _e.sent();
                            headers["content-type"] = "application/json";
                            _e.label = 2;
                        case 2: return [4 /*yield*/, CardsavrCrypto.Signing.signRequest(path, this._appName, sessionKey, requestBody)];
                        case 3:
                            authHeaders = _e.sent();
                            Object.assign(headers, authHeaders);
                            if (this._debug) {
                                console.log("REQUEST " + method + " " + path);
                                console.log(headers);
                                if (requestBody) {
                                    console.log(unencryptedBody);
                                }
                            }
                            config = {
                                headers: headers,
                                method: method,
                                body: requestBody ? JSON.stringify(requestBody) : undefined
                            };
                            if (!(typeof window === "undefined")) return [3 /*break*/, 5];
                            agent = (this._proxy) ?
                                new https_proxy_agent_1.HttpsProxyAgent(this._proxy) :
                                new https_1.Agent(__assign({ rejectUnauthorized: this._rejectUnauthorized }, (this._cardsavrCert && { ca: this._cardsavrCert })));
                            config = Object.assign(config, {
                                agent: agent,
                                timeout: 10000
                            });
                            return [4 /*yield*/, (0, node_fetch_1.default)(new URL(path, this._baseUrl).toString(), config)];
                        case 4:
                            /*
                            const agent_config = {
                                connectTimeout : 10000,
                                connect : {
                                    rejectUnauthorized : this._rejectUnauthorized,
                                    ...(this._cardsavrCert && {ca : this._cardsavrCert})
                                }};
                
                            const dispatcher = this._proxy ?
                                new ProxyAgent({ uri : this._proxy, ...agent_config}) :
                                new Agent(agent_config);
                
                            const config = {
                                    dispatcher,
                                    ...config
                                } as any;
                
                            */
                            response = _e.sent();
                            return [3 /*break*/, 7];
                        case 5: return [4 /*yield*/, window.fetch(new URL(path, this._baseUrl).toString(), config)];
                        case 6:
                            response = _e.sent();
                            _e.label = 7;
                        case 7:
                            if (!((_d = response.headers.get("content-type")) === null || _d === void 0 ? void 0 : _d.startsWith("application/json"))) return [3 /*break*/, 9];
                            return [4 /*yield*/, response.json()];
                        case 8:
                            _a = (_e.sent());
                            return [3 /*break*/, 10];
                        case 9:
                            _a = null;
                            _e.label = 10;
                        case 10:
                            body = _a;
                            if (!(response.status <= 400 && response.headers.get("x-cardsavr-authorization"))) return [3 /*break*/, 12];
                            response_headers = {};
                            response_headers["x-cardsavr-authorization"] = response.headers.get("x-cardsavr-authorization");
                            response_headers["x-cardsavr-nonce"] = response.headers.get("x-cardsavr-nonce");
                            response_headers["x-cardsavr-signature"] = response.headers.get("x-cardsavr-signature");
                            return [4 /*yield*/, CardsavrCrypto.Signing.verifySignature(response_headers, path, this._appName, [sessionKey], body)];
                        case 11:
                            _e.sent();
                            _e.label = 12;
                        case 12:
                            _b = CardsavrSessionResponse_1.default.bind;
                            _c = [void 0, response.status,
                                response.statusText,
                                response.headers];
                            return [4 /*yield*/, CardsavrCrypto.Encryption.decryptResponse(sessionKey, body)];
                        case 13:
                            csr = new (_b.apply(CardsavrSessionResponse_1.default, _c.concat([_e.sent(), path])))();
                            if (csr.statusCode >= 400) {
                                if (csr.statusCode === 401) {
                                    this._sessionData = { sessionKey: sessionKey, sessionToken: "", userId: -1 };
                                }
                                throw new CardsavrRestError_1.default(csr);
                            }
                            if (this._debug) {
                                console.log("RESPONSE");
                                console.log(csr.statusCode);
                                console.log(csr.headers);
                                if (csr.body) {
                                    console.log(csr.body);
                                }
                            }
                            return [2 /*return*/, csr];
                    }
                });
            });
        };
        this.get = function (path_1, filter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([path_1, filter_1], args_1, true), void 0, function (path, filter, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = (0, CardsavrSessionUtilities_1.formatPath)(path, filter);
                            return [4 /*yield*/, this.sendRequest(path, "GET", undefined, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.post = function (path_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([path_1, body_1], args_1, true), void 0, function (path, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = (0, CardsavrSessionUtilities_1.formatPath)(path, null);
                            return [4 /*yield*/, this.sendRequest(path, "POST", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.put = function (path_1, filter_1, body_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([path_1, filter_1, body_1], args_1, true), void 0, function (path, filter, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = (0, CardsavrSessionUtilities_1.formatPath)(path, filter);
                            return [4 /*yield*/, this.sendRequest(path, "PUT", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.delete = function (path_1, filter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([path_1, filter_1], args_1, true), void 0, function (path, filter, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = (0, CardsavrSessionUtilities_1.formatPath)(path, filter);
                            return [4 /*yield*/, this.sendRequest(path, "DELETE", undefined, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this._login = function (username, password) { return __awaiter(_this, void 0, void 0, function () {
            var key_pair, client_public_key, encrypted_login_body, passwordKey, _a, _b, loginResponse, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHkeyPair()];
                    case 1:
                        key_pair = _d.sent();
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHPublicKey(key_pair)];
                    case 2:
                        client_public_key = _d.sent();
                        encrypted_login_body = {
                            username: username,
                            client_public_key: client_public_key
                        };
                        if (!password) return [3 /*break*/, 5];
                        return [4 /*yield*/, CardsavrCrypto.Keys.generatePasswordKey(username, password)];
                    case 3:
                        passwordKey = _d.sent();
                        _a = encrypted_login_body;
                        _b = "password_proof";
                        return [4 /*yield*/, CardsavrCrypto.Signing.signSaltWithPasswordKey(this._sessionData.sessionKey, passwordKey)];
                    case 4:
                        _a[_b] = _d.sent();
                        return [3 /*break*/, 6];
                    case 5: throw new CardsavrSDKError_1.default([], "Must include password to initialize session.");
                    case 6: return [4 /*yield*/, this.sendRequest("/session/login", "post", encrypted_login_body)];
                    case 7:
                        loginResponse = _d.sent();
                        _c = this._sessionData;
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHSecretKey(loginResponse.body.server_public_key, key_pair)];
                    case 8:
                        _c.sessionKey = _d.sent();
                        this._sessionData.userId = loginResponse.body.user_id;
                        this.setSessionToken(loginResponse.body.session_token);
                        return [2 /*return*/, loginResponse];
                }
            });
        }); };
        this.setTrace = function (username, trace) {
            if (!trace)
                trace = {};
            if (trace instanceof Object && !trace.key)
                trace.key = username;
            _this.setSessionHeaders({ "x-cardsavr-trace": JSON.stringify(trace) });
        };
        this.init = function (username, password, trace) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setTrace(username, trace);
                        return [4 /*yield*/, this._login(username, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.assume = function (username, trace) { return __awaiter(_this, void 0, void 0, function () {
            var test_user, key_pair, client_public_key, encrypted_login_body, loginResponse, assumed_session, _a;
            var _b;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.getUsers({ username: username })];
                    case 1:
                        test_user = (_d = (_c = (_e.sent())) === null || _c === void 0 ? void 0 : _c.body) === null || _d === void 0 ? void 0 : _d[0];
                        if (!test_user) {
                            throw new CardsavrSDKError_1.default([], "username ".concat(username, " cannot be assumed."));
                        }
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHkeyPair()];
                    case 2:
                        key_pair = _e.sent();
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHPublicKey(key_pair)];
                    case 3:
                        client_public_key = _e.sent();
                        encrypted_login_body = {
                            client_public_key: client_public_key
                        };
                        return [4 /*yield*/, this.sendRequest("/session/assume/".concat(test_user.id), "post", encrypted_login_body)];
                    case 4:
                        loginResponse = _e.sent();
                        assumed_session = new CardsavrSession(this._baseUrl, "", this._appName, this._rejectUnauthorized, this._cardsavrCert, this._proxy, this._debug);
                        _a = assumed_session;
                        _b = {};
                        return [4 /*yield*/, CardsavrCrypto.Keys.makeECDHSecretKey(loginResponse.body.server_public_key, key_pair)];
                    case 5:
                        _a._sessionData = (_b.sessionKey = _e.sent(),
                            _b.userId = loginResponse.body.user_id,
                            _b);
                        assumed_session.setTrace(username, trace);
                        assumed_session.setSessionToken(loginResponse.body.session_token);
                        return [2 /*return*/, assumed_session];
                }
            });
        }); };
        this.end = function () { return __awaiter(_this, void 0, void 0, function () {
            var ret, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ret = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.get("/session/end", null)];
                    case 2:
                        ret = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this._sessionData = { sessionKey: "", sessionToken: "", userId: -1 };
                        return [2 /*return*/, ret];
                }
            });
        }); };
        this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.put("/session/refresh", null, {})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getAccounts = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardsavr_accounts", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createAccount = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.post("/cardsavr_accounts", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateAccount = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, envelope_id, safeKey, headersToAdd) {
                if (envelope_id === void 0) { envelope_id = null; }
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            if (envelope_id) { //envelope_id required to send a credential_re
                                Object.assign(headersToAdd, { "x-cardsavr-envelope-id": envelope_id });
                            }
                            return [4 /*yield*/, this.put("/cardsavr_accounts", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteAccount = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardsavr_accounts", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getAddresses = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardsavr_addresses", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createAddress = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/cardsavr_addresses", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateAddress = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/cardsavr_addresses", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteAddress = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardsavr_addresses", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getBins = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardsavr_bins", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createBin = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/cardsavr_bins", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateBin = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/cardsavr_bins", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteBin = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardsavr_bins", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getFinancialInstitutions = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/financial_institutions", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createFinancialInstitution = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/financial_institutions", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateFinancialInstitution = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/financial_institutions", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteFinancialInstitution = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/financial_institutions", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getCards = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardsavr_cards", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createCard = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.post("/cardsavr_cards", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateCard = function (id_1, body_1, safeKey_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1, safeKey_1], args_1, true), void 0, function (id, body, safeKey, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.put("/cardsavr_cards", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteCard = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardsavr_cards", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getCardPlacementResults = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/card_placement_results", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getIntegrators = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/integrators", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createIntegrator = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/integrators", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateIntegrator = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/integrators", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteIntegrator = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/integrators", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getSites = function (filter_1, pagingHeader_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1, pagingHeader_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.getMerchantSites(filter, pagingHeader, headersToAdd)];
                });
            });
        };
        this.getMerchantSites = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/merchant_sites", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.registerForJobStatusUpdates = function (jobId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1], args_1, true), void 0, function (jobId, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/messages/place_card_on_single_site_jobs/".concat(jobId, "/broadcasts/registrations"), {
                                job_id: jobId
                            }, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getCardholderMessages = function (cardholderId_1, cardsavrMessagingAccessKey_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([cardholderId_1, cardsavrMessagingAccessKey_1], args_1, true), void 0, function (cardholderId, cardsavrMessagingAccessKey, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (cardsavrMessagingAccessKey) {
                                headersToAdd = Object.assign({
                                    "x-cardsavr-cardsavr-messaging-access-key": cardsavrMessagingAccessKey
                                }, headersToAdd);
                            }
                            return [4 /*yield*/, this.get("/messages/cardholders", cardholderId, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getJobStatusUpdate = function (jobId_1, cardsavrMessagingAccessKey_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1, cardsavrMessagingAccessKey_1], args_1, true), void 0, function (jobId, cardsavrMessagingAccessKey, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            headersToAdd = Object.assign({
                                "x-cardsavr-cardsavr-messaging-access-key": cardsavrMessagingAccessKey
                            }, headersToAdd);
                            return [4 /*yield*/, this.get("/messages/place_card_on_single_site_jobs/".concat(jobId, "/broadcasts"), null, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getJobInformationRequest = function (jobId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1], args_1, true), void 0, function (jobId, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.get("/messages/place_card_on_single_site_jobs/".concat(jobId, "/credential_requests"), null, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getJobInformationResponse = function (jobId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1], args_1, true), void 0, function (jobId, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.get("/messages/place_card_on_single_site_jobs/".concat(jobId, "/credential_responses"), null, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.requestJobInformation = function (jobId_1, type_1, message_1, account_link_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1, type_1, message_1, account_link_1], args_1, true), void 0, function (jobId, type, message, account_link, headersToAdd) {
                var body;
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            body = {
                                jobId: jobId,
                                type: type,
                                message: message,
                                account_link: account_link
                            };
                            return [4 /*yield*/, this.post("/messages/place_card_on_single_site_jobs/".concat(jobId, "/credential_requests"), body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.sendJobInformation = function (jobId_1, envelope_id_1, type_1, message_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1, envelope_id_1, type_1, message_1], args_1, true), void 0, function (jobId, envelope_id, type, message, headersToAdd) {
                var body;
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            body = {
                                envelope_id: envelope_id,
                                type: type,
                                message: message
                            };
                            return [4 /*yield*/, this.post("/messages/place_card_on_single_site_jobs/".concat(jobId, "/credential_responses"), body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getUsers = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardsavr_users", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createUser = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, financial_institution, headersToAdd) {
                if (financial_institution === void 0) { financial_institution = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (financial_institution) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-financial-institution": financial_institution
                                });
                            }
                            return [4 /*yield*/, this.post("/cardsavr_users", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateUser = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/cardsavr_users", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updatePassword = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.put("/cardsavr_users/".concat(id, "/update_password"), null, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteUser = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardsavr_users", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.authorizeCardholder = function (grant_1, source_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([grant_1, source_1], args_1, true), void 0, function (grant, source, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/cardholders/authorize", { grant: grant, source: source }, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateCardholderSession = function (filter, body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.put("/cardholder_sessions", filter, body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getCardholder = function (filter_1, safeKey_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1, safeKey_1], args_1, true), void 0, function (filter, safeKey, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.get("/cardholders", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getCardholders = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/cardholders", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createCardholder = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, safeKey, financial_institution, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (financial_institution === void 0) { financial_institution = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (body && !body.cuid) {
                                body.cuid = (0, CardsavrSessionUtilities_1.generateUniqueUsername)();
                            }
                            if (financial_institution) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-financial-institution": financial_institution
                                });
                            }
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.post("/cardholders", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateCardholder = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, newSafeKey, safeKey, headersToAdd) {
                if (newSafeKey === void 0) { newSafeKey = null; }
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (newSafeKey != null) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(newSafeKey, true));
                            }
                            if (safeKey != null) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey, false));
                            }
                            return [4 /*yield*/, this.put("/cardholders", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteCardholder = function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardholders", id, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.deleteCardholders = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, headersToAdd) {
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.delete("/cardholders", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getSingleSiteJobs = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/place_card_on_single_site_jobs", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createSingleSiteJob = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.post("/place_card_on_single_site_jobs", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.createSingleSiteJobs = function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.post("/place_card_on_single_site_jobs", body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateSingleSiteJob = function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.put("/place_card_on_single_site_jobs", id, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.updateSingleSiteJobs = function (filter_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1, body_1], args_1, true), void 0, function (filter, body, safeKey, headersToAdd) {
                if (safeKey === void 0) { safeKey = null; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (safeKey) {
                                Object.assign(headersToAdd, this._makeSafeKeyHeader(safeKey));
                            }
                            return [4 /*yield*/, this.put("/place_card_on_single_site_jobs", filter, body, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.getJobResults = function (filter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([filter_1], args_1, true), void 0, function (filter, pagingHeader, headersToAdd) {
                if (pagingHeader === void 0) { pagingHeader = {}; }
                if (headersToAdd === void 0) { headersToAdd = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (Object.keys(pagingHeader).length > 0) {
                                Object.assign(headersToAdd, {
                                    "x-cardsavr-paging": JSON.stringify(pagingHeader)
                                });
                            }
                            return [4 /*yield*/, this.get("/card_placement_results", filter, headersToAdd)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this._headers = {};
        this._cardsavrCert = cardsavrCert;
        this._baseUrl = baseUrl;
        this._appName = appName;
        this._debug = debug;
        this._rejectUnauthorized = rejectUnauthorized;
        this._proxy = proxy;
        if (this._proxy && this._cardsavrCert) {
            throw new CardsavrSDKError_1.default(["Shouldn't be providing explicit certificate with proxy configuration."]);
        }
        this._sessionData = { sessionKey: sessionKey, sessionToken: "", userId: -1 };
        this.setSessionToken("null");
        this.setSessionHeaders({
            "x-cardsavr-client-application": "".concat(appName, " - Strivve SDK v").concat(package_json_1.version),
        });
    }
    CardsavrSession.prototype.getSessionUserId = function () {
        var _a;
        return +((_a = this._sessionData) === null || _a === void 0 ? void 0 : _a.userId);
    };
    return CardsavrSession;
}());
exports.CardsavrSession = CardsavrSession;
//# sourceMappingURL=CardsavrJSLibrary-2.0.js.map